import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../components/Shared/Input/Icon';
import { useDirection } from '../../hooks';
import { Glyph } from '../../iconography/Glyph';
import { InputContainer } from '../InputContainer';
import { StyledInputSelector } from './StyledInputSelector';

export const InputSelector = ({
  value,
  onChange = () => {},
  focus,
  onFocus = () => {},
  onBlur = () => {},
  disabled,
  invalid,
  children,
  id,
  ...rest
}) => {
  const isRtl = useDirection();

  return (
    <InputContainer
      focus={focus}
      disabled={disabled}
      invalid={invalid}
      {...rest}
    >
      <StyledInputSelector
        value={value || ''}
        focus={focus}
        disabled={disabled}
        isRtl={isRtl}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        invalid={invalid}
        id={id}
        {...rest}
      >
        {children}
      </StyledInputSelector>
      <Icon
        icon={
          <Glyph
            category="Arrows"
            name="ChevronDown"
            size={['tiny', 'small']}
          />
        }
        disabled={disabled}
        focus={focus}
        invalid={invalid}
        reverse={!isRtl}
      />
    </InputContainer>
  );
};

InputSelector.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  invalid: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};
